import { SearchMetadata } from "@nerdjs/nerd-core";
import { postalApi } from "../api/postalApi";

export const emailEndpoints = postalApi.injectEndpoints({
  endpoints: (build) => ({
    getEmailSearchMetadata: build.query<SearchMetadata, void>({
      query: () => `emails/searchMetadata`,
    }),
  }),
});

export const { useGetEmailSearchMetadataQuery } = emailEndpoints;

export default emailEndpoints;
